import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';

@Component({
  standalone: false,
  templateUrl: './theatre-add-pack-to-basket-dialog.component.html',
  styleUrls: ['./theatre-add-pack-to-basket-dialog.component.scss'],
})
export class TheatreAddPackToBasketDialog implements OnInit {
  canAddPackWithUnavailableMaterials: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public pack,
    public addPackToBasketDialog: MatDialogRef<TheatreAddPackToBasketDialog>,
    private readonly settingService: SettingsService
  ) {}

  ngOnInit() {
    this.canAddPackWithUnavailableMaterials = this.settingService.getBooleanSetting('enableAddPackWithUnavailableMaterials');
  }
}
